// @flow
import { PRODUCT_STRENGTHS } from 'Client/cms/toolkit/constants';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_STRENGTHS } from 'Utils/request/requestDictionary';

type CMSProps = {|
  id: string,
  isExclusiveCollection: boolean,
  items: Array<{
    iconName: IconName,
    label: string,
    url?: string,
  }>,
  resortId: string,
  title: string,
|};

export const productStrengthsResolver = {
  name: PRODUCT_STRENGTHS,
  resolve(appContext: AppContext, { resortId }: CMSProps) {
    const query = `query {
      config {
        common {
          loadLess
          loadMore
        }
      }
      resort(resortId:"${resortId}"){
        comfort
        type
        isJoyview
      }
    }`;

    return gqlClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_STRENGTHS,
      strictErrors: false,
    });
  },
};
